import React, {useEffect} from 'react'
import {RouteMatch} from 'data/types'
import {Route, Switch, useLocation} from 'react-router-dom'
import Problems from 'views/Problems'
import EmptyProjectView from './empty'
import {usePublished} from 'utils/published'
import services from 'services'
import requiresLoggedIn from 'views/hoc/loggedIn'

type ProjectViewProps = {
  match: RouteMatch<{projectId: string}>
}

function ProjectView(props: ProjectViewProps) {
  const location = useLocation()
  const selectedProject = usePublished(services.getProjectsService().selectedProject)

  useEffect(() => {
    if (location.pathname === '/projects' && selectedProject != null) {
      services.router.selectProject(selectedProject.id)
    }
  }, [location, selectedProject])

  return (
    <Switch>
      <Route exact path="/projects" component={EmptyProjectView} />
      <Route path="/projects/:projectId" component={Problems} />
    </Switch>
  )
}

export default requiresLoggedIn(ProjectView)
